module.exports = __webpack_public_path__ + "static/domestic_mental_obj04@2x-bab2144e0a6a96371caed5198afa8a1a.jpg";